import { Outlet, ScrollRestoration } from 'react-router';
import { useRouteDocumentTitle } from '@/shared/routing';

/** Top-level route element: cross-cutting, layout-agnostic concerns only. */
export function RootLayout() {
  useRouteDocumentTitle();
  return (
    <>
      <Outlet />
      <ScrollRestoration />
    </>
  );
}
